/************************************************/
/* Variables                                    */
/************************************************/
var viewModel = new sm.portal.vm.DocumentListViewModel();
var AdmissionsAttemptGID = '';
var windowURL = window.URL;
var currentLoaded = 0;
var isBlockedUI = true;
/************************************************/
/* Page Object                                   */
/************************************************/
(function ($, undefined) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.page === "undefined") {
        $.extend(sm.portal, { page: {} });
    }
    if (typeof sm.portal.page.documentChecklist === "undefined") {
        $.extend(sm.portal.page, { documentChecklist: {} });
    }

    function initPage() {
        viewModel = new sm.portal.vm.DocumentListViewModel();
        $.when(
            sm.portal.vm.custom.loadCustomTemplate(),
            sm.portal.utility.loadTemplate('ValidationFieldTemplate', 'validationTemplates'),
            sm.portal.utility.loadTemplate('TermsAndConditionsTemplate', 'formTemplates'),
            sm.portal.utility.loadTemplate('PortalValidationMessagesTemplate', 'portalValidationMessagesTemplates'),
            sm.portal.utility.loadTemplate('PortalInformationMessagesTemplate', 'portalInformationMessagesTemplate'),
            sm.portal.utility.loadTemplate('UploadHighSchoolFileTemplate', 'formTemplates'),
            sm.portal.utility.loadTemplate('UploadCollegeFileTemplate', 'formTemplates'),
            sm.portal.utility.loadTemplate('UploadAdmissionsDocumentTemplate', 'formTemplates'),
        ).done(function () {
            viewModel.LoadInitialData();
            viewModel.TemplatesLoaded(true);
            viewModel.PageReady();
        });

        // Bind to Page Elements
        ko.applyBindings(viewModel);
    }

    function setChange(element, valueAccessor) {
        $(element).change(function () {
            var file = this.files[0];
            var fileName = file.name;
            var uploadID = $("#CurrentUploadID");
            uploadID.val(this.id);
            var validationMsg = sm.portal.utility.getResourceValue('ValidationMsgForFileFilterUpload');

            if (!sm.portal.utility.isValidFileType(fileName)) {
                $(element).parents('.uploadControl').addClass('fileTypeError');
                $(element).parents('.fileTypeError').each(function () {
                    if ($(element).parents('.fileTypeError').find('.errorMsg').length <= 0) {
                        $('<div class = "errorMsg" role="alert">' + validationMsg + '</div>').insertAfter($(this).find('.uploadArea'));
                    }

                });
                return false;
            }

            if (ko.isObservable(valueAccessor())) {
                valueAccessor()(file);
            }
        });
    }

    function doUpdate(element, valueAccessor, allBindingsAccessor, currentModel, bindingContext) {

        var file = ko.utils.unwrapObservable(valueAccessor());
        var bindings = allBindingsAccessor();
        var activeIndicator = $(".loadingIndicator.active");
        var uploadID = $("#CurrentUploadID");

        sm.portal.ui.clearUpload(element);

        if (file && uploadID.val() !== "" && uploadID.val() === element.id) {
            sm.portal.ui.loadingIndicator(element);

            $(this).find('.errorMsg').remove();

            //post the file
            var data = new FormData();
            data.append("UploadedFile", file);

            // Set the document ID
            var documentID = 0;
            if (currentModel.model.TranscriptDocumentID !== "undefined") {
                documentID = currentModel.model.TranscriptDocumentID;
            }

            // Set the Attempt ID 
            var attemptID = 0;
            attemptID = $("#AdmissionsRecordID").val();

            // Set the Entity ID (HighSchool ID in the case of HS, College ID in the case of College, etc)
            var subitemId = 0;
            var entityId = 0;
            switch (element.name) {
                case "uploadCollegeFile":
                    subitemId = currentModel.model.CollegeID;
                    entityId = currentModel.model.ID;
                    break;
                case "uploadHighschoolFile":
                    subitemId = currentModel.model.HighSchoolID;
                    entityId = currentModel.model.ID;
                    break;
                default:
                    subitemid = 0;
                    documentID = currentModel.model.ID;
                    break;
            }

            // Set the Stage Name
            var addmissionOfferId = 0;
            var url = '';
            stageName = currentModel.model.StageBusinessMeaning;
            if (stageName === "Application.AdmissionsOffer") {
                addmissionOfferId = currentModel.model.AdmissionsOfferID;
                url = _baseApiUri + "api/studentdocumentchecklist/savefile?documentID=" + documentID + "&elementID=" + 'uploadAdmissionsOfferForm' + "&attemptID=" + attemptID + "&subitemID=" + subitemId + "&entityId=" + entityId + "&stagename=" + encodeURIComponent(stageName) + "&admissionsOfferID=" + addmissionOfferId;
            } else {
                url = _baseApiUri + "api/studentdocumentchecklist/savefile?documentID=" + documentID + "&elementID=" + element.name + "&attemptID=" + attemptID + "&subitemID=" + subitemId + "&entityId=" + entityId + "&stagename=" + encodeURIComponent(stageName);
            }

            $.ajax({
                type: "POST",
                url: url,
                contentType: false,
                processData: false,
                crossDomain: true,
                data: data,
                headers: {
                    "x-api-version": '1' //,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    updateUrls(data);

                    //reset the upload ID so we don't call this again when the file is updated during LoadModel
                    $("#CurrentUploadID").val("")

                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    viewModel.LoadModel(container);

                    sm.portal.ui.readyPage();
                    sm.portal.ui.clearUpload(element);
                    sm.portal.ui.successIndicator(element, data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    viewModel.HandleError(exception);
                }
            });
        }


        if (viewModel.selecDoc !== currentModel.model.DocumentName) {
            return false;
        }

        function updateUrls(data) {
            var updateElement = data.Payload.elementID + "Download";

            // Rebind the newly added DOM elements
            if (document.getElementById(updateElement) != null) {
                ko.cleanNode(document.getElementById(updateElement));

                var tmpViewModel = new UpdateListViewModel();
                tmpViewModel.ThumbnailUrl(data.Payload.thumbnailUrl);
                tmpViewModel.DownloadUrl(data.Payload.downloadUrl);
                tmpViewModel.ID = data.Payload.elementID;

                ko.applyBindings(tmpViewModel, document.getElementById(updateElement));
            }
        }

        function UpdateListViewModel() {
            this.ThumbnailUrl = ko.observable();
            this.DownloadUrl = ko.observable();
            this.Document = ko.observable();
        }

    };

    function doApplicationUpdate() {

        var attemptID = $("#AdmissionsRecordID").val();
        if (!sm.portal.utility.isNullOrEmpty(attemptID)) {
            var url = _baseApiUri + "api/studentdocumentchecklist/updateStage?attemptID=" + attemptID;

            $.ajax({
                type: "GET",
                url: url,
                contentType: false,
                processData: false,
                crossDomain: true,
                headers: {
                    "x-api-version": '1' //,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    viewModel.HandleError(exception);
                }
            });
        }
    }

    function changeRecord() {
        var recordID = $('#AdmissionsRecordID').val();
        currentLoaded = sm.portal.vm.custom.callCustomization('ChangeRecordCustom',recordID)

        if (recordID != undefined && recordID > 0 && recordID != currentLoaded) {
            currentLoaded = recordID;
            var url = _baseApiUri + 'api/studentdocumentchecklist/get/?gid=0' + '&recordid=' + recordID;

            sm.portal.page.documentChecklist.doGet(url);
        }
        else {
            isBlockedUI = false;
        }
    }

    function doGet(url) {
        $.blockUI();

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                "x-api-version": '1' //,
            },
            processData: false,
            crossDomain: true,

            xhrFields: {
                withCredentials: true
            },
            success: function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                if (data.Status == 'success') {

                    viewModel.IsError(false);
                    viewModel.LoadModel(container);

                    var ifallTransactionArePaid = container.Payload.ApplicationFee.every(function (element) {
                        return element.Paid;
                    });
                    var ifallDepositTransactionArePaid = container.Payload.DepositFee.every(function (element) {
                        return element.Paid;
                    });
                    viewModel.IsPaid(ifallTransactionArePaid);
                    viewModel.IsDepositPaid(ifallDepositTransactionArePaid)
                    AttachMakePaymentOnPaymentInformation();
                    AttachMakePaymentOnDepositInformation();
                    ShowBackgroundProcessingInformation();
                    ShowBackgroundProcessingErrors();

                } else if (data.Status == 'validationerror') {

                    viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                    // TODO: Identify and highlight the associated fields (if possible)

                } else if (data.Status == 'error') {

                    viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                }

                sm.portal.ui.readyPage();
                if (data.Status == 'success' && url.includes('recordid=0') && isBlockedUI) {
                    $.blockUI();
                } else {
                    $.unblockUI();
                }
            },
            error: function (jqXHR, exception) {

                if (jqXHR.status == 401) {
                    sm.portal.vm.custom.callCustomization('doGetCustom',null,function(){
                        $('.smHeaderLogin button').click();
                    })

                    var title = sm.portal.utility.getResourceValue('UnAuthorized');
                    var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                    viewModel.HandleError(title, [body]);
                } else {
                    viewModel.HandleError(exception);
                }
                $.unblockUI();
            }
        });

    };

    this.AttachMakePaymentOnPaymentInformation = function () {
        $('button[data-payment-button]').on('click', function () {
            MakePayment(viewModel.ApplicationFee());
        });
    };
    this.AttachMakePaymentOnDepositInformation = function () {
        $('button[data-deposit-payment-button]').on('click', function () {
            MakePayment(viewModel.DepositFee());
        });
    };

    this.ShowBackgroundProcessingInformation = function () {
        var message = sm.portal.utility.getResourceValue('AdmissionsBackgroundProcessing');
        var newMessage  = sm.portal.vm.custom.callCustomization('ShowInfoMessage');
        if(!sm.portal.utility.isNullOrEmpty(newMessage)){
            message =  newMessage ;
        }
        var header = sm.portal.utility.getResourceValue('Information');

        var messageFoundIndex = viewModel.Messages.indexOf(message);
        var messageFound = messageFoundIndex !== -1;
        if (viewModel.IsBackgroundProcessing()) {
            if (!messageFound)
                viewModel.Messages.push(message);
        }
        else {
            if (messageFound)
                viewModel.Messages.splice(messageFoundIndex, 1);
        }

        var showMessage = viewModel.Messages().length > 0
        viewModel.ShowMessages(showMessage);
        viewModel.Header(header);
    };

    this.ShowBackgroundProcessingErrors = function () {
        var message = sm.portal.utility.getResourceValue('AdmissionsBackgroundProcessingError');
        var header = sm.portal.utility.getResourceValue('Error');

        var messageFoundIndex = viewModel.ErrorMessages.indexOf(message);
        var messageFound = messageFoundIndex !== -1;
        if (viewModel.IsBackgroundProcessingError()) {
            if (!messageFound)
                viewModel.ErrorMessages.push(message);

            viewModel.IsError(true);
            viewModel.ErrorHeader(header);
        }
        else {
            if (messageFound)
                viewModel.ErrorMessages.splice(messageFoundIndex, 1);

            viewModel.IsError(false);
        }
    };

    this.MakePayment = function (feeArray) {

        if (feeArray.length < 1) {
            return;
        }
        $.blockUI();
        $.ajax({
            url: _baseApiUri + 'api/Reenrollment/PaymentConfirmationRedirectURL',
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {
                "x-api-version": '1'
            },
            processData: false,
            crossDomain: true,
            async: false,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                var paymentSubmit = { "amount": 0, "DepositPayment": false, "paymentLocation": data.Payload.RedirectPaymentPageURL, "currencyCode": feeArray[0].TransactionCurrency, "admissionsAttemptGID": viewModel.AdmissionsAttemptGid() };
                sm.portal.vm.custom.callCustomization('PaymentLocationCustom', paymentSubmit)
                for (var i = 0; i < feeArray.length; i++) {
                    if (feeArray[i].TransactionCurrency == paymentSubmit['currencyCode']) {
                        paymentSubmit['amount'] += feeArray[i].TransactionAmount;
                    }
                }
                if (feeArray.length > 0) {
                    paymentSubmit.DepositPayment = feeArray[0].DepositPayment;
                }
                if (viewModel.IsBillingDomicilePaymentProviderEnabled()) {
                    paymentSubmit.PaymentProviderID = viewModel.SelectedPaymentProviderId();
                }
                var url = _baseApiUri + sm.portal.utility.formatString('api/portalstudentledger/CreatePaymentForm');
                $.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(paymentSubmit),
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1'
                    },
                    processData: false,
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        if (data.length > 0 && data) {
                            viewModel.IsPaymentProviderEnabled(data);
                            if (feeArray[0].DepositPayment) {
                                $("[data-deposit-payment-button]").wrap(data);
                                $("[data-deposit-payment-button]").appendTo($("[data-deposit-payment-button]").closest('form'));
                                $("[data-deposit-payment-button]").submit();
                            } else {
                                $("[data-payment-button]").wrap(data);
                                $("[data-payment-button]").appendTo($("[data-payment-button]").closest('form'));
                                $("[data-payment-button]").submit();
                            }
                        } else {
                            $.unblockUI();
                        }
                    },
                    error: function (jqXHR, exception) {
                        viewModel.HandleError(exception);
                        $.unblockUI();
                    }
                });
            }
        });
    };

    $.extend(true, sm.portal.page.documentChecklist, {
        initPage: initPage,
        setChange: setChange,
        doUpdate: doUpdate,
        doApplicationUpdate: doApplicationUpdate,
        changeRecord: changeRecord,
        doGet: doGet
    });

})(jQuery);

/************************************************/
/* Event Hooks                                   */
/************************************************/
(function ($) {

    $(document).bind('afterSMInitPage', function () {
        sm.portal.page.documentChecklist.initPage();
    });

})(jQuery);

